export default __webpack_public_path__ + "static/media/alert-circle.93af7b09.svg";